import React from 'react';
import {
    Edit,
    TabbedForm,
    FormTab,
    Toolbar,
    SaveButton,
    TextInput,
    NumberInput,
    ReferenceInput,
    SelectInput
} from 'react-admin';
import {locales} from '../../config/config';

const CashbackConditionItemsEditToolbar = props => (
    <Toolbar {...props}>
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);

class CashbackConditionItemsEdit extends React.Component {
    render() {
        return (
            <Edit {...this.props}>
                <TabbedForm toolbar={<CashbackConditionItemsEditToolbar />}>
                    <FormTab label="general">
                        <ReferenceInput source="cashbackId" reference="cashbacks" label="Cashback Block">
                            <SelectInput optionText="id" optionValue="id" />
                        </ReferenceInput>
                        <NumberInput source="position" label="Position" />
                        <NumberInput source="type" label="Type" />
                        <TextInput source="text" label="Text" multiline fullWidth />
                        <TextInput source="url" label="Url" fullWidth />
                    </FormTab>
                    <FormTab label="style">
                        <TextInput source="textColor" label="Text Color" fullWidth />
                        <TextInput source="textFont" label="Font Size" fullWidth />
                        <TextInput source="textMargin" label="Text Margin" fullWidth />
                        <TextInput source="imageMargin" label="Image Margin" fullWidth />
                    </FormTab>
                    {
                        locales.map(locale => (
                            <FormTab label={`body ${locale}`} key={locale}>
                                <TextInput label={`Text ${locale}`} source={`translations[${locale}].text`} multiline fullWidth />
                                <TextInput label={`Url ${locale}`} source={`translations[${locale}].url`} fullWidth />
                            </FormTab>
                        ))
                    }
                </TabbedForm>
            </Edit>
        );
    }
}

export default CashbackConditionItemsEdit;
